module.exports = __webpack_public_path__ + "img/circleTbank.f82b6fe1.svg";